import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../redux/snackbar';

export default function AlertDialog(data) {
  const [open, setOpen] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    dispatch(setSnackbar(true, 'success', 'Ação Submetida com Sucesso!'));
    data.openDialogSales
      ? data.openDialogSales(true)
      : history.push(data.historyPush);
  };

  const id = data.id.length > 1 ? data.id.map((options) => options.id) : [data.id];

  const handleStatus = async () => {
    id.forEach(async (id) => {
      const reccycle = await api.get(`/cycles/${id}`);

      reccycle.data.status = 'Concluído';

      reccycle.data.end = data.end;
      const dadosCiclo = reccycle.data;
      await api.put(`/cycles/${id}`, { ...dadosCiclo }).then(() => {
        setOpen(false);

        dispatch(setSnackbar(true, 'success', 'Ação Submetida com Sucesso!'));
        if (reccycle.data.population === 0) {
          data.openDialogSales
            ? data.openDialogSales(true)
            : history.push(data.historyPush);
        } else {
          data.dialogRemnantDied(true);
        }
      });
    });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Deseja concluir esse viveiro?
        </DialogTitle>
        <DialogActions style={{ padding: '0rem 1.5rem 1.5rem 0rem' }}>
          <Button
            onClick={handleClose}
            style={{
              border: '1px solid red',
              color: 'red',
            }}
          >
            Não
          </Button>
          <Button
            onClick={handleStatus}
            style={{
              backgroundColor: '#0267C1',
              color: 'white',
            }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
